import {
    processGetManyFilter,
    processGetManyByReferenceFilter,
    processFilters,
    processGetManyByReferenceChildren,
    addSortToUrl, readJsonOrRefuse, refuseOnHttpError} from "./provider/defaults";
import {
    CreateParams,
    CreateResult,
    DataProvider,
    DeleteManyParams,
    DeleteParams,
    GetListParams,
    GetListResult,
    GetManyParams,
    GetManyReferenceParams,
    GetManyReferenceResult,
    GetManyResult,
    GetOneParams,
    GetOneResult,
    UpdateManyParams,
    UpdateManyResult,
    UpdateParams,
    UpdateResult
} from "react-admin";
import { read_cookie, delete_cookie } from 'sfcookies';
import { hostUrl, UseUrlManagerCleanUrl, apiUrl } from "../components/utils/url-manager";
import { addUrlToUri, removeUrlFromUri, restoreEntityString, cleanEntityString } from "./provider/defaults";
import {CompaniesHouse, CompaniesHouseFilingHistory} from "../types/entities";

function cleanParams(companiesHouse: any[]): CompaniesHouse {
    return {
        id: companiesHouse['id'],
        status: companiesHouse['status'],
        company: cleanEntityString(companiesHouse['company'], '/hq_api/companies/'),
        companyName: companiesHouse['companyName'],
        type: companiesHouse['type'],
        incorporatedOn: companiesHouse['incorportatedOn'],
        previousAccounts: companiesHouse['previousAccounts'],
        nextAccounts: companiesHouse['nextAccounts'],
        nextAccountsDue: companiesHouse['nextAccountsDue'],
        previousConfirmationStatement: companiesHouse['previousConfirmationStatement'],
        nextConfirmationStatement: companiesHouse['nextConfirmationStatement'],
        nextConfirmationStatementDue: companiesHouse['nextConfirmationStatementDue'],
        filingHistory: removeUrlFromUri(companiesHouse['filingHistories'], '/hq_api/filing_histories/'),
        people: removeUrlFromUri(companiesHouse['companiesHousePeople'], '/hq_api/companies_house_peoples/'),
        addresses: removeUrlFromUri(companiesHouse['companiesHouseAddresses'], '/hq_api/companies_house_addresses/')
    }
}

const adminCompaniesHouseDataProvider: DataProvider = {

    getList:  async  (resource: string, params: GetListParams) : Promise<GetListResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processFilters(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: CompaniesHouse[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let companiesHouses: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < companiesHouses.length; i++) {
                        let companiesHouse: any[] = companiesHouses[i];
                        responseData.data.push(cleanParams(companiesHouse))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
        //return Promise.reject();
    },
    // get a single record by id
    getOne: async (resource: string, params: GetOneParams) : Promise<GetOneResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHouse|null } = {
                    data: null
                };
                if (data['id']) {
                   responseData = {
                        data: cleanParams(data)
                    };
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get a list of records based on an array of ids
    getMany: async (resource: string, params: GetManyParams): Promise<GetManyResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = processGetManyFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHouse[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let companies: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < companies.length; i++) {
                        let companiesHouse: any[] = companies[i];

                        responseData.data.push(cleanParams(companiesHouse))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get the records referenced to another record, e.g. comments for a post
    getManyReference: async (resource: string, params: GetManyReferenceParams) : Promise<GetManyReferenceResult> => {

        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processGetManyByReferenceFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request : Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHouse[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let companiesHouses: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < companiesHouses.length; i++) {
                        let companiesHouse: any[] = companiesHouses[i];
                        responseData.data.push(cleanParams(companiesHouse));
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // create a record
    create: async (resource: string, params: CreateParams) : Promise<CreateResult> => {
        let token: string = read_cookie('auth');
        // set the date as required
        params.data.filingHistories = addUrlToUri(params.data.fillngHistories, '/hq_api/filling_histories/');
        params.data.cmopaniesHouseAddresses = addUrlToUri(params.data.companiesHouseAddresses, '/hq_api/companies_house_addresses/');
        params.data.companiesHousePeople = addUrlToUri(params.data.companiesHousePeople, '/hq_api/companies_house_people/');
        params.data.company = restoreEntityString(params.data.company, '/hq_api/companies/');

        params.data.account = '/hq_api/accounts/' + params.data.account;
        let url: string = apiUrl + resource;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: CompaniesHouse|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    // update a record based on a patch
    update: async (resource: string, params: UpdateParams) : Promise<UpdateResult> => {
        let token: string = read_cookie('auth');

        params.data.filingHistories = addUrlToUri(params.data.fillngHistories, '/hq_api/filling_histories/');
        params.data.cmopaniesHouseAddresses = addUrlToUri(params.data.companiesHouseAddresses, '/hq_api/companies_house_addresses/');
        params.data.companiesHousePeople = addUrlToUri(params.data.companiesHousePeople, '/hq_api/companies_house_people/');
        params.data.company = restoreEntityString(params.data.company, '/hq_api/companies/');
        let url: string = apiUrl + resource + '/' + params.data.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'PATCH',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/merge-patch+json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: CompaniesHouse|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // update a list of records based on an array of ids and a common patch
    updateMany: async (resource: string, params: UpdateManyParams) : Promise<UpdateManyResult> => {
        return Promise.reject();
    },
    // delete a record by id
    delete: async (resource: string, params: DeleteParams) : Promise<any> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return refuseOnHttpError(response)
                    .then((): { data: any } => ({ data: params }));
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // delete a list of records based on an array of ids
    deleteMany: async (resource: string, params: DeleteManyParams) => {
        return Promise.reject();
    },
    getProfileData: (params) => {
        return Promise.resolve();
    }
}


export default adminCompaniesHouseDataProvider;